<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="700px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Фильтры</span>
      </v-card-title>
      <v-card-text>
        <v-tabs
          v-model="tab"
          vertical
        >
          <v-tab
            v-for="t in tabs"
            :key="'tab_' + t.key"
          >
            {{ t.name }}
          </v-tab>
          <v-tab-item
            v-for="t in tabs"
            :key="'item_' + t.key"
          >
            <v-card flat>
              <v-card-text>
                <div
                  v-for="f in t.data"
                  :key="f.field"
                >
                  <v-select
                    v-if="f.type === 'select'"
                    v-model="values[f.field]"
                    :label="f.name"
                    :items="f.select"
                    clearable
                    dense
                  />
                  <skud-date-field
                    v-else-if="f.type === 'date'"
                    v-model="values[f.field]"
                    :label="f.name"
                    :outlined="false"
                  />
                  <v-text-field
                    v-else-if="f.type === 'number'"
                    v-model="values[f.field]"
                    :label="f.name"
                    type="number"
                    clearable
                    dense
                  />
                  <v-checkbox
                    v-else-if="f.type === 'bool'"
                    v-model="values[f.field]"
                    :label="f.name"
                    hint="только да"
                    persistent-hint
                    dense
                  />
                  <v-text-field
                    v-else
                    v-model="values[f.field]"
                    :label="f.name"
                    clearable
                    dense
                  />
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary darken-1"
          outlined
          rounded
          small
          class="ml-2 mb-2"
          @click="apply()"
        >
          <span class="mx-4">Применить</span>
        </v-btn>
        <v-btn
          color="secondary darken-1"
          outlined
          rounded
          small
          class="ml-2 mb-2"
          @click="reset()"
        >
          <span class="mx-4">Сбросить</span>
        </v-btn>
        <v-btn
          color="secondary darken-1"
          outlined
          rounded
          small
          class="ml-2 mb-2"
          @click="show = false"
        >
          <span class="mx-4">Отмена</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Общий фильтр-диалог СКУД. Конфиг полей приходит пропом из списка,
// применённые значения хранятся в localStorage под storageKey.
// Использование: <skud-filter-dialog ref="filter" :fields="..." storage-key="skud.passage" @apply="onFilterApply" />
// Список в mounted восстанавливает фильтр через this.$refs.filter.current().
import SkudDateField from '@/views/skud/components/SkudDateField.vue'

export default {
  name: 'SkudFilterDialog',
  components: {
    SkudDateField
  },
  props: {
    // {tabKey: {index, name, data: [{name, field, type: text|select|date|number|bool, select: [{value, text}]}]}}
    fields: {
      type: Object,
      required: true
    },
    storageKey: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      show: false,
      tab: 0,
      values: {}
    }
  },
  computed: {
    tabs () {
      return Object.keys(this.fields)
        .map(k => ({
          key: k,
          index: this.fields[k].index,
          name: this.fields[k].name,
          data: this.fields[k].data
        }))
        .sort((a, b) => a.index - b.index)
    }
  },
  methods: {
    open () {
      const saved = localStorage.getItem(this.storageKey)
      this.values = saved ? JSON.parse(saved) : {}
      this.show = true
    },
    apply () {
      const cleaned = this.clean(this.values)
      localStorage.setItem(this.storageKey, JSON.stringify(cleaned))
      this.$emit('apply', cleaned)
      this.show = false
    },
    reset () {
      this.values = {}
      localStorage.removeItem(this.storageKey)
      this.$emit('apply', {})
    },
    // Текущие применённые значения без открытия диалога (восстановление в mounted списка).
    current () {
      const saved = localStorage.getItem(this.storageKey)
      return saved ? this.clean(JSON.parse(saved)) : {}
    },
    // Пустые значения в query не уходят.
    clean (values) {
      const out = {}
      for (const k in values) {
        const v = values[k]
        if (v === null || v === undefined || v === '' || v === false) continue
        out[k] = v
      }
      return out
    }
  }
}
</script>
